import React, { useState, useEffect } from "react";

import "./Footer.css";

export const Footer = (props) => {
  return (
    <div className="footerText">
      Beta Version. The Credit Copilot can make mistakes.{" "}
    </div>
  );
};

export default Footer;
